module.exports = __webpack_public_path__ + "img/XK.4f3781ca.svg";